import ItemBrandActions from "./actions";

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form: {},
  isNewRecord: false,
  showModal: false,
  onSubmit: false,
  single: null,
  helperItemBrand: null,
  errorInternal: false,
};

function ItemBrandReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ItemBrandActions.RESET_LIST:
      return INITIAL_STATE;
    case ItemBrandActions.NEW_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        single: null,
        form: INITIAL_STATE.form,
        isNewRecord: true,
        showModal: true,
      };
    case ItemBrandActions.UPDATE_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        single: null,
        isNewRecord: false,
      };
    case ItemBrandActions.VIEW_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        single: action.payload,
        isNewRecord: false,
        showModal: true,
      };
    case ItemBrandActions.RESET_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        form: INITIAL_STATE.form,
        showModal: false,
      };
    case ItemBrandActions.DELETE_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: false,
        form: INITIAL_STATE.form,
        showModal: false,
      };
    case ItemBrandActions.ON_SUBMIT:
      return { ...state, errorInternal: false, onSubmit: true };
    case ItemBrandActions.SHOW_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isError: false,
        data: action.payload,
        errorMessage: [],
        isProcessing: false,
      };
    case ItemBrandActions.SUCCESS_DATA:
      return {
        ...state,
        errorInternal: false,
        isError: false,
        showModal: false,
        form: INITIAL_STATE.form,
        onSubmit: false,
      };
    case ItemBrandActions.PROCESS_DATA:
      return {
        ...state,
        errorInternal: false,
        onSubmit: false,
        isProcessing: true,
        isError: false,
        isSuccess: false,
      };
    case ItemBrandActions.ERROR_DATA:
      return {
        ...state,
        errorInternal: false,
        isError: true,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
      };
    case ItemBrandActions.GET_HELPER_ITEMBRAND:
      return {
        ...state,
        errorInternal: false,
        isError: false,
        isSuccess: false,
        onSubmit: false,
        helperItemBrand: action.payload,
      };
    case ItemBrandActions.ERROR_SERVER:
      return {
        ...state,
        onSubmit: false,
        isError: false,
        errorInternal: true,
        errorMessage: action.payload,
        isProcessing: false,
      };

    default:
      return state;
  }
}

export default ItemBrandReducer;
